define([
	'internal_util/Configuration'
], function (
	Configuration
) {
	'use strict';

	return function () {
		var _canvas = document.createElement('canvas'),
			_context = _canvas.getContext('2d'),
			_animation = false,
			_animationStart,
			_animationTimer;

		_context.canvas.width = 100;
		_context.canvas.height = 100;

		_context.save();

		_context.lineWidth = 2;
		_context.lineCap = "round";

		_context.beginPath();

		_context.moveTo(50, 25);
		_context.lineTo(50, 40);
		_context.strokeStyle = "rgba(100,100,100,1)";
		_context.stroke();

		_context.moveTo(33, 33);
		_context.lineTo(43, 43);
		_context.strokeStyle = "rgba(100,100,100,0.8)";
		_context.stroke();

		_context.moveTo(25, 50);
		_context.lineTo(40, 50);
		_context.strokeStyle = "rgba(100,100,100,0.6)";
		_context.stroke();

		_context.moveTo(33, 67);
		_context.lineTo(43, 57);
		_context.strokeStyle = "rgba(100,100,100,0.4)";
		_context.stroke();

		_context.moveTo(50, 75);
		_context.lineTo(50, 60);
		_context.strokeStyle = "rgba(100,100,100,0.2)";
		_context.stroke();

		_context.moveTo(67, 67);
		_context.lineTo(57, 57);
		_context.strokeStyle = "rgba(100,100,100,0.1)";
		_context.stroke();

		_context.closePath();

		_context.restore();


		// private methods

		function draw(interval, rotateAngle, first) {
			_animationTimer = window.requestAnimationFrame(function () {
				if (!_animation) {
					return;
				}

				if (first || (Date.now() - _animationStart) >= interval) {
					_context.save();

					_context.clearRect(0, 0, _context.canvas.width, _context.canvas.height);

					_context.translate(_context.canvas.width / 2, _context.canvas.height / 2);
					_context.rotate(rotateAngle * (Math.PI/180));
					_context.translate(-1 * (_context.canvas.width / 2), -1 * (_context.canvas.height / 2));

					_context.lineWidth = 2;
					_context.lineCap = "round";

					_context.beginPath();

					_context.moveTo(50, 25);
					_context.lineTo(50, 40);
					_context.strokeStyle = "rgba(100,100,100,1)";
					_context.stroke();

					_context.moveTo(33, 33);
					_context.lineTo(43, 43);
					_context.strokeStyle = "rgba(100,100,100,0.8)";
					_context.stroke();

					_context.moveTo(25, 50);
					_context.lineTo(40, 50);
					_context.strokeStyle = "rgba(100,100,100,0.6)";
					_context.stroke();

					_context.moveTo(33, 67);
					_context.lineTo(43, 57);
					_context.strokeStyle = "rgba(100,100,100,0.5)";
					_context.stroke();

					_context.moveTo(50, 75);
					_context.lineTo(50, 60);
					_context.strokeStyle = "rgba(100,100,100,0.4)";
					_context.stroke();

					_context.moveTo(67, 67);
					_context.lineTo(57, 57);
					_context.strokeStyle = "rgba(100,100,100,0.3)";
					_context.stroke();

					_context.moveTo(75, 50);
					_context.lineTo(60, 50);
					_context.strokeStyle = "rgba(100,100,100,0.2)";
					_context.stroke();

					_context.moveTo(67, 33);
					_context.lineTo(57, 43);
					_context.strokeStyle = "rgba(100,100,100,0.1)";
					_context.stroke();

					_context.closePath();

					_context.restore();

					rotateAngle += 5;

					if (rotateAngle === 360) {
						rotateAngle = 0;
					}

					_animationStart = Date.now();
				}

				draw(interval, rotateAngle, false);
			}, _canvas);
		}


		// public methods

		this.get = function () {
			return _canvas;
		};

		this.enableAnimation = function () {
			_animation = true;
			_animationStart = Date.now();

			draw(Configuration.get('LOADING_CANVAS_INTERVAL'), 0, true);
		};

		this.disableAnimation = function () {
			if (window.cancelAnimationFrame) {
				window.cancelAnimationFrame(_animationTimer);
			}

			_animation = false;
		};
	};
});


//////////////////
// WEBPACK FOOTER
// ./src/main/web/js/app/view/canvas/LoadingCanvas.js
// module id = 53
// module chunks = 1